import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { color, layout } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import Text from 'theme/text';
import Button from 'theme/buttons/btn';
import BtnLink from 'theme/buttons/btn-link';
import CloseIcon from 'theme/icons/close';

const GlobalStyle = createGlobalStyle`
  body {
    overflow-y: hidden;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;

  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(6, 119, 134, 0.6);
  z-index: 999;

  & > div {
    ::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }

    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
    overflow-y: scroll;
    overflow-x: hidden;
  }
`;

const Content = styled.div`
  ${color}
  ${layout}

  border-radius: 12px;
  overflow: hidden;
  padding: ${themeGet('space.s')}px ${themeGet('space.s')}px;

  & > .head {
    background: ${themeGet('colors.white')};

    & > .wrap-close {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
    }

    & > .wrap-title {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
  }

  & > .body {
    display: flex;
    flex-direction: row;
    padding: ${themeGet('space.s')}px ${themeGet('space.l')}px ${themeGet('space.l')}px;
  }

  & > .footer {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 0 ${themeGet('space.s')}px;
  }
`;

function ModalConfirm({
  contentStyle,
  width,
  style,
  isVisible,
  title,
  message,
  onClickCancel,
  onClickOk,
  okLabel,
}) {
  return (
    <Wrapper {...style} isVisible={isVisible}>
      {isVisible && <GlobalStyle />}

      <div>
        <Content width={width || '420px'} bg="white" {...contentStyle}>
          <div className="head">
            <div className="wrap-close">
              <BtnLink
                style={{
                  height: 34,
                  width: 34,
                  minWidth: 34,
                }}
                icon={<CloseIcon />}
                onClick={onClickCancel}
                title="Close"
              />
            </div>
            <div className="wrap-title">
              <Text fontSize="h2" lineHeight="h2" fontWeight="bold" color="grey_600">
                {title}
              </Text>
            </div>
          </div>
          <div className="body">
            <Text
              fontSize="display"
              lineHeight="display"
              fontWeight="medium"
              color="grey_400"
              textAlign="center"
            >
              {message}
            </Text>
          </div>
          <div className="footer">
            <Button
              onClick={onClickOk}
              type="button"
              label={okLabel}
              style={{
                width: '100%',
                paddingLeft: 8,
                paddingRight: 8,
              }}
            />
          </div>
        </Content>
      </div>
    </Wrapper>
  );
}

export default ModalConfirm;
